<template>
    <ul v-if="Object.keys(optionGroups).length > 0">
        <!-- LOOP ALL OPTIONS -->
        <!-- <li class="group row m-b-20" v-for="(og, index) in optionGroups" v-show="!excludeOptionGroups.includes(og.uuid)"> -->
        <li class="group row m-b-20" v-for="(uuid) in optionGroupSorting" :key="uuid" v-if="optionGroups[uuid]" v-show="!excludeOptionGroups.includes(uuid)">
            <label v-bind:for="optionGroups[uuid].safe_name?optionGroups[uuid].safe_name:optionGroups[uuid].name" class="col-sm-5">
                <a v-if="optionGroups[uuid].modal_details" href="#" @click.prevent="showModal(optionGroups[uuid].modal_details)">[?]</a>
                <!-- Selector labels -->
                <span v-if="optionGroups[uuid].safe_name">{{ optionGroups[uuid].safe_name }}</span>
                <span v-else>{{ optionGroups[uuid].name }}</span>
            </label>
            <div class="col-sm-7">
                <select class="form-control" :name="optionGroups[uuid].uuid" :disabled="optionGroups[uuid].disabled" @change="filterProducts($event)" v-model="selected_options[optionGroups[uuid].uuid]">
                    <option value="null" v-if="!selected_options[optionGroups[uuid].uuid]">Select One</option>
                    <option v-for="option in optionGroups[uuid].options.data" :value="option.uuid" :data-name="option.name" :data-alert="option.alert" v-if="(optionGroups[uuid].uuid !== runsize_uuid || (optionGroups[uuid].uuid === runsize_uuid && runsize_cost[option.name] !== undefined)) && !excludeOptionGroups.includes(option.uuid)" :key="option.uuid">
                        <span v-if="option.safe_name">{{ option.safe_name }}</span>
                        <span v-else>{{ option.name }}</span>
                        <span v-if="optionGroups[uuid].uuid === runsize_uuid && runsize_cost[option.name]"> - ${{ runsize_cost[option.name].toFixed(2) }}</span>
                        <span v-if="option.price !== null && option.price !== undefined"> - ${{ option.price.toFixed(2) }}</span>
                    </option>
                </select>
            </div>
        </li>

        <!-- EDDM DATE -->
        <li class="group row m-b-20" v-if="$store.state.template.eddm_only">
            <label for="turnaround" class="col-sm-5">
                <a href="#" @click.prevent="showModal('<p>Choose the date that you wish to have the postcards delivered in the mailboxes. Please note that issues with artwork, files or delays in placing your order today may cause delays.<br /><br />The selected dates are subject to USPS® Mail Service Delivery. The USPS® may deliver the postcards early, late or on the target date at their discretion.</p>')">[?]</a>
                In Mailbox Date
            </label>
            <div class="col-sm-7" v-if="calendar.openDate !== ''">
                <datepicker :openDate="calendar.openDate" :disabledDates="calendar.disabledDates" format="MM/dd/yyyy" input-class="form-control" v-model="selected.date" @selected="initNextSelector(true)"></datepicker>
                <small>*USPS® may deliver before or after the selected target estimate <a href="#" @click.prevent="showModal('<p>Choose the date that you wish to have the postcards delivered in the mailboxes. Please note that issues with artwork, files or delays in placing your order today may cause delays.<br /><br />The selected dates are subject to USPS® Mail Service Delivery. The USPS® may deliver the postcards early, late or on the target date at their discretion.</p>')">more info</a></small>
            </div>
            <div class="col-sm-7" v-else>
                <input type="text" class="form-control" disabled="disabled" placeholder="Loading, please wait.." />
            </div>
        </li>

        <li class="group row m-b-0">
            <div class="col-md-12">
                <div class="pull-right m-b-20" style="font-size: 30px;" v-show="!this.$store.state.template.eddm_only">{{ estimatedCost() }}</div>
            </div>
        </li>

        <li class="group row m-b-0">
            <div class="col-md-12">
                <button :class="{disabled: (proceed !== true)}" class="btn btn-success pull-right" @click="checkProceed()">{{ button }}</button>
            </div>
        </li>

    </ul>
</template>
<script>
import _ from 'lodash'
import Datepicker from 'vuejs-datepicker'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'

// HIDE OPTION IF ONLY ONE OPTION IS AVAILABLE
// SHOW OPTIONS COST BEFORE SELECTOR BUILD

export default{
    name: 'ProductSelector',
    components: { Datepicker },
    props: {
        products: {
            default: () => []
        },
        eddmDates: {
            default: () => []
        },
        button: {
            default: 'Add to cart'
        },
        selected: {
            default: {
                product: null,
                product_cost: null,
                runsize: null,
                runsizeDescription: null,
                colorspec: null,
                options: null,
                name: null,
                turnaround: null,
                shipping: null,
                blind: null,
                date: null,
                method: null
            }
        }
    },
    data () {
        return {
            runsize_uuid: '87e09691-ef33-4cf4-8f17-48af06ce84f4',
            colorspec_uuid: '38d33954-5a42-4112-a905-215eb827e62c',
            productsLoaded: false,
            proceed: false,
            optionGroups: {},
            optionGroupSorting: [],
            excludeOptionGroups: [],
            forceSkipOptionGroups: [],
            selected_products: [],
            preselected_options: [],
            selected_options: [],
            runsize_cost: [],
            runsizes: [],
            min_runsize: 0,
            calendar: {
                openDate: '',
                disabledDates: {
                    // to: new Date(2016, 0, 5), // Disable all dates up to specific date
                    // from: new Date(2016, 0, 26), // Disable all dates after specific date
                    days: [6, 0] // Disable Saturday's and Sunday's
                }
            }
        }
    },
    created () {
        let settings = this.$store.state.template.productsettings.data[0]
        let exclude = []
        // Always Hide EDDM Option
        exclude.push('038bcdd0-0e1a-4de4-ad8c-2c4cc0df7d56') // EDDM Option
        this.forceSkipOptionGroups.push('038bcdd0-0e1a-4de4-ad8c-2c4cc0df7d56') // EDDM Option

        // EDDM - Force No Bundling & EDDM Option
        if (this.$store.state.template.eddm_only) {
            exclude.push('87e09691-ef33-4cf4-8f17-48af06ce84f4') // Runsize
            exclude.push('254afeea-1fd1-4efb-b5fb-c9c3bf4c13d2') // Bundling
            this.preselected_options['254afeea-1fd1-4efb-b5fb-c9c3bf4c13d2'] = '58689abb-25c0-461c-a4c3-a80b627d6649'
            this.preselected_options['038bcdd0-0e1a-4de4-ad8c-2c4cc0df7d56'] = 'aa0227f0-877e-4ecd-bdfd-d220d74098db'
        }

        if (this.selected.colorspec) {
            exclude.push('38d33954-5a42-4112-a905-215eb827e62c')
            this.preselected_options['38d33954-5a42-4112-a905-215eb827e62c'] = this.selected.colorspec
        }

        if (settings.subcategories[Object.keys(settings.subcategories)[0]].exclude) {
            let excludeList = settings.subcategories[Object.keys(settings.subcategories)[0]].exclude
            for (let i in excludeList) {
                exclude.push(excludeList[i])
            }
        }
        this.excludeOptionGroups = exclude
    },
    watch: {
        products: function (newVal, oldVal) {
            if (this.productsLoaded === false) {
                this.productsLoaded = true
                this.init()
            }
        },
        eddmDates: function (newVal, oldVal) {
            this.calendar.openDate = new Date(newVal[0])
            this.calendar.disabledDates.to = new Date(newVal[0])
            this.calendar.disabledDates.from = new Date(newVal[(newVal.length - 1)])
        },
        selected: function (newVal, oldVal) {
            this.$emit('updateSelected', newVal)
        }
    },
    methods: {
        /**
         * Loop our products, build out all available options and init our selected prods to start with
         */
        init () {
            // Init our selected products if it hasn't been done.
            if (this.selected_products.length < 1) {
                let products = JSON.parse(JSON.stringify(this.products))
                for (let i in products) {
                    this.selected_products.push(products[i])
                }
            }

            this.initNextSelector()
        },

        checkProceed () {
            if (this.proceed) {
                this.$emit('next')
            }
            return false
        },

        /**
         * Loop over selected products and build option groups
         */
        buildOptions () {
            let reset = []
            let touch = +new Date()

            for (let i in this.selected_products) {
                let prod = this.selected_products[i]

                for (let x in prod.option_groups.data) {
                    let optionGroup = prod.option_groups.data[x]

                    // If optiongroup is disabled or undefined
                    if (optionGroup.disabled !== false) {
                        this.optionGroupSorting[optionGroup.sorting] = optionGroup.uuid

                        // Reset - If option group is set & an option hasn't been selected yet & it hasn't been reset yet
                        if (this.optionGroups.hasOwnProperty(optionGroup.uuid) && this.selected_options[optionGroup.uuid] === null && !reset.includes(optionGroup.uuid)) {
                            reset.push(optionGroup.uuid)
                            this.optionGroups[optionGroup.uuid].options.data = {}
                        }

                        // If Option Group Doesn't Exist
                        if (!this.optionGroups.hasOwnProperty(optionGroup.uuid)) {
                            reset.push(optionGroup.uuid)

                            optionGroup.disabled = true

                            this.$set(this.optionGroups, optionGroup.uuid, optionGroup)

                            if (!this.selected_options[optionGroup.uuid]) {
                                this.selected_options[optionGroup.uuid] = null
                            }

                        // Else - Merge options with option group
                        } else {
                            let og = this.optionGroups[optionGroup.uuid]
                            let currentOptionGroups = []

                            // Build array of existing options
                            let index = 0
                            let orderedOptions = {} // reset index of object keys to 0, because was overwriting items on the merge below
                            for (let x in og.options.data) {
                                currentOptionGroups.push(og.options.data[x].uuid)
                                orderedOptions[index] = og.options.data[x]
                                index++
                            }

                            // Merge in new options if they don't exist
                            for (let i in optionGroup.options.data) {
                                if (!currentOptionGroups.includes(optionGroup.options.data[i].uuid)) {
                                    orderedOptions[currentOptionGroups.length] = optionGroup.options.data[i]
                                    currentOptionGroups.push(optionGroup.options.data[i].uuid)
                                }
                            }
                            og.options.data = orderedOptions

                            // Set option group
                            this.$set(this.optionGroups, optionGroup.uuid, og)
                        }

                        // Touch
                        this.optionGroups[optionGroup.uuid].touch = touch
                    }
                }
            }

            for (let i in this.optionGroups) {
                if (this.optionGroups[i].touch < touch) {
                    this.$delete(this.optionGroups, i)
                }
            }

            this.cleanOptions() // Remove Selectors w/ Only 1 Option?
        },

        /**
         * Remove option groups with only 1 option
         */
        cleanOptions () {
            for (let i in this.optionGroupSorting) {
                if (this.optionGroups[this.optionGroupSorting[i]] !== undefined) {
                    this.optionGroups[this.optionGroupSorting[i]] = this.filterExcludedOptions(this.optionGroups[this.optionGroupSorting[i]])

                    // Remove Option Groups
                    if (this.optionGroups[this.optionGroupSorting[i]] && this.optionGroups[this.optionGroupSorting[i]].options.data.length < 2 && this.optionGroupSorting[i] !== '38d33954-5a42-4112-a905-215eb827e62c') {
                        if (this.optionGroups[this.optionGroupSorting[i]].options.data.length > 0) {
                            // Assign only available option if it's not eddm only
                            if (this.optionGroups[this.optionGroupSorting[i]].options.data[0].uuid === 'e629d351-623c-48f6-b5ea-db43d1387a97' && this.$store.state.template.eddm_only || this.optionGroups[this.optionGroupSorting[i]].options.data[0].uuid !== 'e629d351-623c-48f6-b5ea-db43d1387a97') {
                                this.selected_options[this.optionGroups[this.optionGroupSorting[i]].uuid] = this.optionGroups[this.optionGroupSorting[i]].options.data[0].uuid
                            }
                        }

                        // Remove option group
                        this.$delete(this.optionGroups, this.optionGroupSorting[i])
                    }
                }
            }

            let sorted = _.chain(this.optionGroups)
                .map((val, key) => {
                    return { name: key, data: val, sort: parseInt(val.sorting) }
                })
                .sortBy('sort')
                .keyBy('name')
                .mapValues('data')
                .value()

            this.optionGroups = sorted

            this.$forceUpdate()
        },

        /**
         * Remove excluded options from the option group
         * @param  {object} optionGroup
         * @return {object} filtered option group
         */
        filterExcludedOptions (optionGroup) {
            let optionGroupData = optionGroup.options.data

            for (let x in optionGroupData) {
                let option = optionGroupData[x]
                if (this.excludeOptionGroups.includes(option.uuid)) {
                    this.$delete(optionGroupData, x)
                }
            }
            optionGroup.options.data = optionGroupData

            return optionGroup
        },

        /**
         * Popup a modal for explaining an option group or options function
         * @param  {string} html data to be displayed in modal
         */
        showModal (html) {
            swal({
                html: '<div style="text-align: left;">' + html + '</div>',
                showCloseButton: false
            })
        },

        /**
         * Loop selected options and filter out products based on options selected thus far
         */
        filterProducts ($event) {
            let selector = $event.target
            if (selector !== undefined) {
                if (selector.options[selector.selectedIndex] !== undefined) {
                    let alert = selector.options[selector.selectedIndex].getAttribute('data-alert')

                    if (alert !== null && alert !== '' && alert.length > 0) {
                        this.showModal(alert)
                    }
                }

                // Reset all selectors below the target
                let clear = false
                const keys = Object.keys(this.optionGroupSorting)
                let lastIndex = keys.length - 1
                for (let i in this.optionGroupSorting) {
                    if (this.optionGroupSorting[i] === selector.name) {
                        clear = true
                        if (keys.indexOf(i) === lastIndex) {
                            if (this.optionGroups[this.optionGroupSorting[i]] !== undefined && this.optionGroups[this.optionGroupSorting[i]].disabled !== undefined) {
                                this.optionGroups[this.optionGroupSorting[i]].disabled = false
                            }
                            this.buildSelection()
                            this.proceed = true
                        }
                    } else if (clear === true && (!this.$store.state.template.eddm_only || (this.$store.state.template.eddm_only && this.selected.date !== true))) { // && !this.excludeOptionGroups.includes(this.optionGroupSorting[i])
                        this.selected_options[this.optionGroupSorting[i]] = null
                        if (this.optionGroups[this.optionGroupSorting[i]] !== undefined) {
                            this.optionGroups[this.optionGroupSorting[i]].disabled = true
                        }
                    } else if (clear === true && (this.$store.state.template.eddm_only && this.selected.date === true)) {
                        this.proceed = true
                    }
                }

                // Set the optiongroup pricing
                if (selector.name === this.runsize_uuid) {
                    this.calculateOptionsCost(selector.value)
                } else {
                    this.calculateOptionsCost()
                }

                // Push all available products into the pending list to be filtered
                let products = JSON.parse(JSON.stringify(this.products))
                let filteredProducts = {}
                for (let x in products) {
                    filteredProducts[x] = products[x]
                }

                // Loop selected options so far and remove products that don't match
                for (let i in this.optionGroupSorting) {
                    if (this.selected_options[this.optionGroupSorting[i]]) {
                        let option = this.selected_options[this.optionGroupSorting[i]]
                        if (option !== null) {
                            for (let p in filteredProducts) {
                                if (!this.findOption(filteredProducts[p], this.optionGroupSorting[i], option)) {
                                    delete filteredProducts[p]
                                }
                            }
                        }
                    }
                }

                // Push filtered list into the selected products
                this.selected_products.length = 0
                for (let x in filteredProducts) {
                    this.selected_products.push(filteredProducts[x])
                }

                if (selector.disabled === false) {
                    this.initNextSelector()
                }
            }
        },

        /**
         * Loop a product to detect if it has a specific option available to it
         * @param  {object} product     Product Data
         * @param  {string} optiongroup Optiongroup UUID
         * @param  {string} option      Option UUID
         * @return {boolean}            Option found?
         */
        findOption (product, optiongroup, option) {
            let found = false

            for (let i in product.option_groups.data) {
                if (product.option_groups.data[i].uuid === optiongroup) {
                    let options = product.option_groups.data[i].options.data
                    for (let o in options) {
                        if (options[o].uuid === option) {
                            found = true
                        }
                    }
                }
            }

            return found
        },

        /**
         * Initialize the next selector and confirm that it's still viable with the selected products
         * @param  {string} uuid Current selector uuid
         */
        initNextSelector (date = false) {
            this.buildOptions()
            let nextSelector = false

            for (let i in this.optionGroupSorting) {
                if (this.optionGroups[this.optionGroupSorting[i]]) {
                    if (this.optionGroups[this.optionGroupSorting[i]].disabled === true && !this.forceSkipOptionGroups.includes(this.optionGroups[this.optionGroupSorting[i]].uuid)) {
                        this.optionGroups[this.optionGroupSorting[i]].disabled = false
                        nextSelector = true

                        if (this.preselected_options[this.optionGroupSorting[i]]) {
                            setTimeout(() => {
                                $('select[name="' + this.optionGroupSorting[i] + '"]').val(this.preselected_options[this.optionGroupSorting[i]])
                                $('select[name="' + this.optionGroupSorting[i] + '"]')[0].dispatchEvent(new Event('change', { 'bubbles': true }))
                            }, 500)
                        }

                        // if (this.optionGroups[this.optionGroupSorting[i]] && Object.keys(this.optionGroups[this.optionGroupSorting[i]].options.data).length < 2 && this.optionGroupSorting[i] !== '38d33954-5a42-4112-a905-215eb827e62c') {
                        //     $('select[name="' + this.optionGroupSorting[i] + '"]').val(this.optionGroups[this.optionGroupSorting[i]].options.data[Object.keys(this.optionGroups[this.optionGroupSorting[i]].options.data)[0]].uuid)
                        //     $('select[name="' + this.optionGroupSorting[i] + '"]')[0].dispatchEvent(new Event('change', { 'bubbles': true }))

                        //     this.excludeOptionGroups.push(this.optionGroupSorting[i])
                        //     this.initNextSelector()
                        // }

                        break
                    }
                }
            }

            this.calculateOptionsCost()

            if (nextSelector === false && (!this.$store.state.template.eddm_only || this.selected.date === true)) {
                this.buildSelection()
                this.proceed = true
            }
        },

        /**
         * Build and output the selected product and options
         */
        buildSelection () {
            let selected = this.selected
            selected.options = []
            for (let i in this.optionGroupSorting) {
                if (this.selected_options[this.optionGroupSorting[i]] && this.selected_options[this.optionGroupSorting[i]] !== null) {
                    if (this.optionGroupSorting[i] === this.runsize_uuid) {
                        selected.runsize = this.selected_options[this.optionGroupSorting[i]]
                        selected.runsizeDescription = $('select[name=' + this.optionGroupSorting[i] + '] > option:selected').attr('data-name')
                    } else if (this.optionGroupSorting[i] === this.colorspec_uuid) {
                        selected.colorspec = this.selected_options[this.optionGroupSorting[i]]
                    } else {
                        selected.options.push(this.selected_options[this.optionGroupSorting[i]])
                    }
                }
            }
            // Update Selected w/ Product
            if (this.selected_products.length < 2) {
                selected.product = this.selected_products[0]
                selected.product_cost = parseFloat(this.estimatedCost().replace('$', ''))
            }

            this.$set(this.selected, selected)
        },

        /**
         * Run and return a cost estimation of the product
         * @return {string} Total calculated cost
         */
        estimatedCost () {
            let price = null
            let options = 0
            let product = null
            // Filters
            let runsizeUuid = this.selected_options[this.runsize_uuid]
            let colorspecUuid = this.selected_options[this.colorspec_uuid]

            for (let i in this.selected_products) {
                let prod = this.selected_products[i]

                let filterRunsize = (runsizeUuid !== null && runsizeUuid !== undefined) ? runsizeUuid : false
                let filterColorspec = (colorspecUuid !== null && colorspecUuid !== undefined) ? colorspecUuid : false

                for (let x in prod.detail.data) {
                    let prodDetail = prod.detail.data[x]

                    if (filterRunsize !== false && filterColorspec !== false) {
                        if (prodDetail.runsize_uuid === runsizeUuid && prodDetail.colorspec_uuid === colorspecUuid) {
                            if (prodDetail.price <= price || price === null) {
                                product = prod
                                price = prodDetail.price
                                this.setRunsizeCosts(prod)
                            }
                        }
                    } else if (filterRunsize !== false) {
                        if (prodDetail.runsize_uuid === runsizeUuid) {
                            if (prodDetail.price <= price || price === null) {
                                product = prod
                                price = prodDetail.price
                                this.setRunsizeCosts(prod)
                            }
                        }
                    } else if (filterColorspec !== false) {
                        if (prodDetail.colorspec_uuid === colorspecUuid) {
                            if (prodDetail.price <= price || price === null) {
                                product = prod
                                price = prodDetail.price
                                this.setRunsizeCosts(prod)
                            }
                        }
                    } else {
                        if (prodDetail.price <= price || price === null) {
                            product = prod
                            price = prodDetail.price
                            this.setRunsizeCosts(prod)
                        }
                    }
                }
            }

            // Loop Selected Options & Estimate Options Cost
            if (product !== null) {
                for (let x in this.optionGroups) {
                    let og = this.optionGroups[x]
                    if (this.selected_options[og.uuid] !== null) {
                        for (let o in og.options.data) {
                            let option = og.options.data[o]
                            if (this.selected_options[og.uuid] === option.uuid && option.price !== undefined && option.price !== null) {
                                options += option.price
                            }
                        }
                    }
                }
            }

            if (price > 0 && price !== null) {
                return '$' + (price + options).toFixed(2)
            } else {
                return 'Sorry, an error has occured.'
            }
        },

        /**
         * Calculate total cost of all options
         * @param  {string} uuid Uuid of selected runsize
         * @return {float}
         */
        calculateOptionsCost (uuid = null) {
            this.min_runsize = 0
            let runsize = this.runsizes[Object.keys(this.runsizes)[0]]

            if (uuid !== null) {
                runsize = this.runsizes[uuid]
            }

            for (let i in this.optionGroups) {
                let og = this.optionGroups[i]
                let options = og.options.data
                for (let x in options) {
                    let opt = options[x]
                    if (opt.pricing !== undefined) {
                        let pricing = opt.pricing.data
                        let first = false
                        for (let p in pricing) {
                            let price = pricing[p]
                            // No runsize is defined - choose minimum
                            if (this.selected_options[og.uuid] === opt.uuid && first === false) {
                                // Set Min Runsize
                                if (this.min_runsize < price.startqty) {
                                    this.min_runsize = price.startqty
                                }
                                first = true
                            }

                            // If we fall within the runsize range
                            if ((price.startqty !== undefined && price.startqty <= runsize) && (price.endqty === undefined || price.endqty >= runsize)) {
                                // Calculate Price
                                if (price.price_per_qty !== undefined) {
                                    opt.price = price.price + ((runsize / price.qty) * price.price_per_qty)
                                } else if (price.price > 0) {
                                    opt.price = price.price
                                }
                                break
                            }
                        }
                    }
                }
            }
        },

        /**
         * Set all of the runsize costs of the cheapest available product in selected products
         * this will ultimately be narrowed down to one product and return the correct cost
         * @param {object} prod Product Data
         */
        setRunsizeCosts (prod) {
            let colorspecUuid = this.selected_options[this.colorspec_uuid]
            this.runsize_cost.length = 0

            for (let i in prod.detail.data) {
                let detail = prod.detail.data[i]
                if ((detail.runsize >= this.min_runsize && colorspecUuid && colorspecUuid === detail.colorspec_uuid) || (detail.runsize >= this.min_runsize && !colorspecUuid)) {
                    this.runsize_cost[detail.runsize] = detail.price
                    this.runsizes[detail.runsize_uuid] = detail.runsize
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// ProductSelector.vue?1293976b